import React from 'react';
import './LoadingScreen.css';

/**
 * Premium Loading Screen 
 * @param {string} title - Main title text
 * @param {string} subtitle - Support text
 * @param {boolean} mini - If true, renders a small inline version
 */
const LoadingScreen = ({ title = "Loading Egurukul", subtitle = "Preparing your personalized experience...", mini = false }) => {
    if (mini) {
        return (
            <div className="mini-loader-wrapper">
                <div className="mini-spinner"></div>
                <div className="mini-text">{title}</div>
            </div>
        );
    }

    return (
        <div className="loading-screen-overlay">
            <div className="loader-content">
                <div className="spinner-container">
                    <div className="spinner-outer-ring"></div>
                    <div className="spinner-inner-ring"></div>
                    <div className="spinner-center-icon">E</div>
                </div>
                <div className="loading-text-container">
                    <h2 className="loading-title">{title}</h2>
                    <p className="loading-subtitle">{subtitle}</p>
                </div>
            </div>
        </div>
    );
};

export const MiniLoader = ({ message = "Loading..." }) => (
    <LoadingScreen title={message} mini={true} />
);

export default LoadingScreen;
